const GameScreenElement = require('../elements/gamescreen.js')
const SpriteSelector = require('./spriteselector.js')
const SpriteHighlights = require('./spritehighlights.js')
const GlitchWires = require('./glitch-wires.js')
const GlitchEditor = require('../nanocomponents/glitch-editor.js')
module.exports = function GameScreen (state, emit) {
  let onMouseMove = null
  let onMouseUp = null
  let onMouseDown = null
  let onMouseLeave = null
  let children = []
  if (!state.spriteOperationsAllowed) {
    children = [state.canvas]
    if (state.projectMetadata.hideCursor) {
      state.canvas.style.cursor = 'none'
    }
    onMouseDown = e => emit('playMouseDown', e)
    onMouseUp = e => emit('playMouseUp', e)
    onMouseMove = e => emit('playMouseMove', e)
    onMouseLeave = e => emit('playMouseMove', e)
    return GameScreenElement(
      { children, onMouseMove, onMouseUp, onMouseLeave, onMouseDown }
    )
  }
  const spriteSelector = SpriteSelector(state, emit)

  children = [
    state.canvas,
    spriteSelector
  ]


  onMouseDown = e => {
    emit('click-on-game', e)
    emit('playMouseDown', e)
  }
  onMouseUp = e => emit('playMouseUp', e)
  onMouseMove = e => emit('playMouseMove', e)


  onMouseLeave = e => {
    emit('playMouseMove', e)
    emit('clear-hovering-target')
    if (state.movingSelectedTarget) {
      emit('remove-target-from-play-area', e)
    }
    if (state.draggingGlitchApplication) {
      emit('drag-glitch-off-play-area')
    }
  }

  return GameScreenElement(
    { children, onMouseMove, onMouseUp, onMouseLeave, onMouseDown }
  )
}
